import { Color } from '@shinetools/suntheme';
import { reduceWhile } from 'ramda';

import locales from '../locales';
import { BeneficiaryInvitation, CompanyLegalBeneficiaryStatus } from '../types';

const COLOR_BY_STATUS: Record<CompanyLegalBeneficiaryStatus, Color> = {
  IN_PROGRESS: 'lightBlue',
  IN_REVIEW: 'lightBlue',
  INVALID: 'red',
  NOT_STARTED: 'orange',
  REFUSED: 'red',
  VALIDATED: 'turquoise',
};

const COLOR_PREDS: {
  (
    invitation: BeneficiaryInvitation,
    onBoardingStatus: CompanyLegalBeneficiaryStatus,
  ): Color | null;
}[] = [
  (invitation) => (invitation.inviteeEmail ? null : COLOR_BY_STATUS.REFUSED),
  (invitation, onboardingStatus) =>
    onboardingStatus === 'NOT_STARTED' && !invitation.canResendInvite
      ? 'grey'
      : null,
  (invitation, onboardingStatus) => COLOR_BY_STATUS[onboardingStatus],
];

export const badgeColor = (
  invitation: BeneficiaryInvitation,
  onboardingStatus: CompanyLegalBeneficiaryStatus,
): Color =>
  reduceWhile(
    (accu) => accu === 'grey',
    (accu, predicate) => predicate(invitation, onboardingStatus) || accu,
    'grey' as Color,
    COLOR_PREDS,
  );

const TEXT_BY_STATUS: Record<CompanyLegalBeneficiaryStatus, string> = {
  IN_PROGRESS: locales.statusInProgress,
  IN_REVIEW: locales.statusInReview,
  INVALID: locales.statusInvalid,
  NOT_STARTED: locales.statusNotStarted,
  REFUSED: locales.statusRefused,
  VALIDATED: locales.statusValidated,
};

export const badgeStatus = (
  invitation: BeneficiaryInvitation,
  onboardingStatus: CompanyLegalBeneficiaryStatus,
): string => {
  return invitation.inviteeEmail
    ? TEXT_BY_STATUS[onboardingStatus]
    : locales.statusEmailMissing;
};
